exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#HistoryChangesModal .v--modal-box.v--modal{min-width:410px!important;min-height:300px!important}#HistoryChangesModal :not(.v-icon){font-size:12px}#HistoryChangesModal .modal__footer{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c29eed78","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/HistoryChanges.vue
// module id = 1988
// module chunks = 0